import { Box } from "@chakra-ui/react";
import { InputV2, SelectV2 } from "../../../Reusable";
import { Label } from "../../../Components/ui/label";
import { Input } from "../../../Components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../../Components/ui/select";
import RadioButtonGroup from "../../../Components/RadioButtonGroup/RadioButtonGroup";
import { signupRadioButtons } from "../../../utils/helper";
import CitiesAndStates from "../../../Components/CitiesAndStates/CitiesAndStates";

const StepGeneralInfo = ({ formik }) => {
  return (
    <div className="space-y-4" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
      {/* First Name and Last Name - Required by backend but shown in grid to match Figma style */}
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="name.firstName">First Name *</Label>
          <InputV2
            placeholder="First name"
            name="name.firstName"
            restInput={{ maxLength: 150 }}
            value={formik.values.name.firstName}
            cypressInputSelector="cypress-edit-first-name"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="name.lastName">Last Name *</Label>
          <InputV2
            placeholder="Last name"
            name="name.lastName"
            restInput={{ maxLength: 150 }}
            value={formik.values.name.lastName}
            cypressInputSelector="cypress-edit-last-name"
          />
        </div>
      </div>

      {/* Title/Role */}
      <div className="space-y-2">
        <Label htmlFor="title">Executive Director, Program Manager, etc.</Label>
        <InputV2
          placeholder="Executive Director, Program Manager, etc."
          name="title"
          restInput={{ maxLength: 150 }}
          value={formik.values.title}
          cypressInputSelector="cypress-edit-title"
        />
      </div>

      {/* Location - Using CitiesAndStates but styled to match Figma */}
      <div className="space-y-2">
        <Label htmlFor="location">City, State/Country</Label>
        <CitiesAndStates formik={formik} />
      </div>

      {/* Gender - Full width */}
      <div className="space-y-2 w-full">
        <Label htmlFor="gender">Select</Label>
        <Box className="w-full" style={{ maxWidth: '100%', overflow: 'hidden' }}>
          <RadioButtonGroup
            name="gender"
            options={signupRadioButtons[0].options}
            formik={formik}
            notListedFieldName={signupRadioButtons[0].notListedField}
            data-cy="cypress-radio-button-gender"
          />
        </Box>
      </div>

      {/* Pronouns - Full width */}
      <div className="space-y-2 w-full">
        <Label htmlFor="pronouns">she/her, he/him, they/them</Label>
        <Box className="w-full" style={{ maxWidth: '100%', overflow: 'hidden' }}>
          <RadioButtonGroup
            name="pronouns"
            options={signupRadioButtons[1].options}
            formik={formik}
            notListedFieldName={signupRadioButtons[1].notListedField}
            data-cy="cypress-radio-button-pronouns"
          />
        </Box>
      </div>

      {/* Ethnicity (Optional) - Full width */}
      <div className="space-y-2 w-full">
        <Label htmlFor="ethnicity">Your ethnicity</Label>
        <Box className="w-full" style={{ maxWidth: '100%', overflow: 'hidden' }}>
          <RadioButtonGroup
            name="ethnicity"
            options={signupRadioButtons[2].options}
            formik={formik}
            notListedFieldName={signupRadioButtons[2].notListedField}
            data-cy="cypress-radio-button-ethnicity"
          />
        </Box>
      </div>
    </div>
  );
};

export default StepGeneralInfo;
